import * as React from 'react';

function SvgPlayicon(props) {
  return (
    <svg
      width={57}
      height={56}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.68 42.771l15.575-13.588a1.156 1.156 0 000-1.739l-15.58-13.67a1.155 1.155 0 00-1.91.871v27.256a1.155 1.155 0 001.915.87z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPlayicon;
